module.exports = __webpack_public_path__ + "img/lessonLearn_img.dd3fbbb7.svg";